export enum DataLayerCustomDimensions {
  MemebershipType = 'Membership Type',
  RolesType = 'Role Type',
  Location = 'Club Hierarchy',
  caName = "CA",
  appName = "Application",
  multipleDistrictName = 'Multiple District',
  districtName = 'District',
  event = 'event',
  eventCategory = 'eventCategory',
  eventAction = 'eventAction',
  eventLabels = 'eventLabels'
}
